
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"170.4","height":"170.4","viewBox":"0 0 45.085 45.085","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M45.085 22.54c0 12.45-10.093 22.543-22.542 22.543C10.093 45.083 0 34.991 0 22.54 0 10.09 10.093-.002 22.543-.002S45.085 10.091 45.085 22.54","fill":"#90dfaa"}}),_c('path',{attrs:{"d":"M22.543 34.93c-.888 0-1.61.722-1.61 1.61a1.61 1.61 0 003.219 0c0-.888-.722-1.61-1.61-1.61m0 3.857a2.25 2.25 0 01-2.247-2.248 2.25 2.25 0 012.248-2.247 2.25 2.25 0 012.247 2.247 2.25 2.25 0 01-2.247 2.248M22.862 34.25h-.639v-3.403h.639z","fill":"#324a5e"}}),_c('path',{attrs:{"d":"M36.186 11.33H8.899v20.118c0 .43.348.777.778.777h25.732c.43 0 .777-.348.777-.777z","fill":"#fff"}}),_c('path',{attrs:{"d":"M37.23 12.33H7.855a.387.387 0 01-.387-.387v-1.236c0-.214.173-.387.387-.387H37.23c.214 0 .387.173.387.387v1.236a.387.387 0 01-.387.387","fill":"#324a5e"}}),_c('path',{attrs:{"d":"M33.389 30.1h-2.584V15.5h2.584z","fill":"#ff7058"}}),_c('path',{attrs:{"d":"M26.983 30.1h2.584V16.766h-2.584z","fill":"#e6e9ee"}}),_c('path',{attrs:{"d":"M23.162 30.1h2.583V19.68h-2.584z","fill":"#84dbff"}}),_c('path',{attrs:{"d":"M21.924 30.1H19.34V18.385h2.584z","fill":"#ffd05b"}}),_c('path',{attrs:{"d":"M18.102 30.1h-2.584v-6.754h2.584z","fill":"#ff7058"}}),_c('path',{attrs:{"d":"M14.28 30.1h-2.584v-9.772h2.584z","fill":"#4cdbc4"}})])
          )
        }
      }
    